/* global google, moment, topbar, t */
import './affiliate.scss';

/**
 * Label color for Google Charts axes/legend, matching the active CP theme.
 *
 * @return {string} Hex color for chart text.
 */
function getGChartLabelColor () {
	return document.documentElement.getAttribute( 'data-bs-theme' ) === 'dark'
		? '#e6ecf2'
		: '#023E5A';
}

/**
 * Affiliate component - handles affiliate overview, settings, commissions, and payments pages.
 */
export default () => {
	const affiliateEl = document.querySelector( '[data-component="affiliate"]' );

	if ( !affiliateEl ) {
		return;
	}

	// Get the page type from data attribute.
	const pageType = affiliateEl.dataset.page || '';

	// Initialize the appropriate page functionality.
	switch ( pageType ) {
		case 'overview':
			initOverviewPage();
			break;
		case 'settings':
			initSettingsPage();
			break;
		case 'commissions':
			initCommissionsPage();
			break;
		case 'payments':
			initPaymentsPage();
			break;
		default:
			break;
	}

	/**
	 * Overview page functionality with charts and date range picker.
	 */
	function initOverviewPage () {
		let areaChart;

		// Initialize Google Charts.
		google.charts.load( 'current', {
			callback: function () {
				// Draw chart.
				drawAreaChart();

				// Resize on sidebar width change.
				const sidebarToggle = document.querySelector( '.sidebar-control' );

				if ( sidebarToggle ) {
					sidebarToggle.addEventListener( 'click', drawAreaChart );
				}

				// Resize on window resize.
				let resizeAreaChart;

				window.addEventListener( 'resize', function () {
					clearTimeout( resizeAreaChart );
					resizeAreaChart = setTimeout( function () {
						drawAreaChart();
					}, 200 );
				} );
			},
			packages: [ 'corechart' ],
		} );

		/**
		 * Draws the area chart with sales and clicks data.
		 */
		function drawAreaChart () {
			const block = $( '.sales-chart-container' );

			$( block ).block( {
				message: '<i class="fas fa-spinner fa-spin"></i>',
				overlayCSS: {
					backgroundColor: '#3e3f47',
					opacity: 0.8,
					cursor: 'wait',
				},
				css: {
					border: 0,
					padding: 0,
					backgroundColor: 'transparent',
				},
			} );

			const startDate = $( '.date-range' ).data( 'daterangepicker' ).startDate.format( 'YYYY-MM-DD' );
			const endDate = $( '.date-range' ).data( 'daterangepicker' ).endDate.format( 'YYYY-MM-DD' );

			setTimeout( function () {
				// Define charts element.
				const areaBasicElement = document.getElementById( 'sales-chart-area' );

				$.ajax( {
					type: 'POST',
					dataType: 'json',
					url: '/cp/modules/affiliate/json/load-statistics.php',
					data: {
						start_date: startDate,
						end_date: endDate,
					},
					success ( result ) {
						$( '.clicks-count' ).html( result.totals.clicks );
						$( '.sales-count' ).html( result.totals.sales );
						$( '.earnings-count' ).html( result.totals.earnings );

						// Create data table from JSON data.
						const data = new google.visualization.DataTable( result.data );
						const labelColor = getGChartLabelColor();

						// Chart options.
						const options = {
							fontName: 'Lato',
							height: 400,
							fontSize: 14,
							areaOpacity: 0.25,
							chartArea: {
								left: '5%',
								width: '94%',
								height: 350,
							},
							pointSize: 7,
							backgroundColor: 'transparent',
							tooltip: {
								textStyle: {
									fontName: 'Lato',
									fontSize: 14,
								},
							},
							vAxis: {
								title: t( 'Aantal' ),
								titleTextStyle: {
									fontSize: 15,
									italic: false,
									color: labelColor,
								},
								textStyle: {
									color: labelColor,
								},
								baselineColor: '#697692',
								gridlines: {
									color: '#4b5975',
									count: 0,
								},
								minorGridlines: {
									color: '#3e495f',
								},
								gridarea: {
									count: 10,
								},
								minValue: 0,
							},
							hAxis: {
								textStyle: {
									color: labelColor,
								},
								format: 'd MMM',
								gridlines: {
									color: '#e3e3e3',
								},
								minorGridlines: {
									color: '#e3e3e3',
								},
							},
							legend: {
								position: 'top',
								alignment: 'center',
								textStyle: {
									fontSize: 14,
									color: labelColor,
								},
							},
							series: {
								0: {
									color: '#CDEDFC',
								},
								1: {
									color: '#FFAC24',
								},
							},
						};

						// Draw chart.
						areaChart = new google.visualization.AreaChart( areaBasicElement );
						areaChart.draw( data, options );

						google.visualization.events.addListener( areaChart, 'ready', function () {
							$( block ).unblock();
						} );
					},
					error () {
						$( '.sales-chart-container' ).hide();
					},
				} );
			}, 200 );
		}

		$( '#select_date_sales' ).on( 'change', function () {
			drawAreaChart();
		} );

		// Initialize date range picker.
		moment.locale( 'nl' );
		const dateRanges = {
		};

		for ( let i = 0;i < 4;i++ ) {
			dateRanges[ moment().subtract( i, 'month' ).endOf( 'month' ).format( 'MMMM' ) ] = [
				moment().subtract( i, 'month' ).startOf( 'month' ),
				moment().subtract( i, 'month' ).endOf( 'month' ),
			];
		}

		// Initialize with options.
		$( '.date-range' ).daterangepicker(
			{
				startDate: moment().startOf( 'month' ),
				endDate: moment().endOf( 'month' ),
				ranges: dateRanges,
				applyClass: 'btn-sm btn-primary',
				cancelClass: 'btn-sm btn-light',
				locale: {
					separator: ' - ',
					applyLabel: 'Bevestigen',
					fromLabel: 'Van',
					toLabel: 'Tot',
					daysOfWeek: [
						'Zo',
						'Ma',
						'Di',
						'Wo',
						'Do',
						'Vr',
						'Za',
					],
					monthNames: [
						'Januari',
						'Februari',
						'Maart',
						'April',
						'Mei',
						'Juni',
						'Juli',
						'Augustus',
						'September',
						'Oktober',
						'November',
						'December',
					],
					firstDay: 0,
					format: 'DD-MM-YYYY',
					cancelLabel: 'Wissen',
					customRangeLabel: 'Zelf opgeven',
				},
			},
			function ( start, end ) {
				$( '.date-range span' ).html( `${start.format( 'DD-MM-YYYY' )} &nbsp;${t( 'tot' )}&nbsp; ${end.format( 'DD-MM-YYYY' )}` );
				drawAreaChart();
			}
		);

		// Display initial date format.
		$( '.date-range span' ).html(
			`${moment().startOf( 'month' ).format( 'DD-MM-YYYY' )} &nbsp;${t( 'tot' )}&nbsp; ${moment().endOf( 'month' ).format( 'DD-MM-YYYY' )}`
		);
	}

	/**
	 * Settings page functionality.
	 */
	function initSettingsPage () {
		const config = JSON.parse( affiliateEl.dataset.config || '{}' );

		// Initialize form validation.
		$( '#settingsForm' ).bootstrapValidator();

		// Hide topbar when clicking download links.
		$( document ).on( 'click', 'a[href*="affiliate-banners"]', function () {
			setTimeout( function () {
				if ( typeof topbar !== 'undefined' ) {
					topbar.hide();
				}
			}, 500 );
		} );

		// Toggle additional conditions.
		$( '#btn_addition_conditions' ).click( function ( e ) {
			e.preventDefault();
			$( '.addition_conditions' ).slideToggle();
		} );

		// SubID toggle functionality.
		$( '#sub_id' ).change( function () {
			$( '.sub_id_container' ).toggle();

			if ( !$( this ).is( ':checked' ) ) {
				$( '#explainer-modal input[name=code]' ).val( function () {
					return $( this ).data( 'value' );
				} );
				$( '#sub_id_string' ).val( '' );
			}
		} );

		// Update affiliate links with SubID.
		$( document ).on( 'keyup', '#sub_id_string', function () {
			const val = $( this ).val();

			$( '#explainer-modal input[name=code]' ).val( function () {
				return `${$( this ).data( 'value' )}&sid=${val}`;
			} );
		} );

		// Show welcome modal for new affiliates.
		if ( config.showWelcomeModal ) {
			$( '#welcome-modal' ).modal( 'show' );
		}

		// Show toast notifications if present.
		showToastNotification( config );
	}

	/**
	 * Commissions page functionality.
	 */
	function initCommissionsPage () {
		loadCommissions();

		$( '#search-container' ).on( 'submit', function ( e ) {
			e.preventDefault();
			loadCommissions();
		} );
	}

	/**
	 * Resets the commissions table.
	 */
	function resetCommissionForm () {
		$( '.commissions-table tbody' ).empty();
	}

	/**
	 * Loads commissions from the server.
	 */
	function loadCommissions () {
		resetCommissionForm();

		const searchPhrase = $( '#input_search' ).val();

		$.ajax( {
			type: 'POST',
			dataType: 'json',
			url: '/cp/modules/affiliate/json/load-commissions.php',
			data: {
				search_phrase: searchPhrase,
			},
			success ( data ) {
				$( '.invoice-count' ).html( data.details.count );
				$( '.invoice-count-container' ).show();

				if ( data.details.count > 0 ) {
					$.each( data.details.commissions, function ( key, commission ) {
						$( '#table.commissions-table tbody' ).append( `
							<tr>
								<td>${commission.date}</td>
								<td>${commission.sub_id}</td>
								<td>${commission.order_nr}</td>
								<td>&euro; ${commission.sale_amount}</td>
								<td>&euro; ${commission.commission_amount}</td>
								<td>${commission.approved}</td>
								<td>${commission.paidout}</td>
							</tr>
						` );
					} );
				} else {
					$( '#table.commissions-table tbody' ).append(
						`<tr><td colspan="7">${t( 'Geen commissies gevonden' )}</td></tr>`
					);
				}
			},
			error ( xhr ) {
				$( '.status' ).addClass( 'bg-danger' );
				$( '.status' ).removeClass( 'bg-success' );
				$( '.status' ).html( $.parseJSON( xhr.responseText ).status_description );
				$( '.status' ).fadeIn();
				setTimeout( function () {
					$( '.status' ).fadeOut();
				}, 10000 );
			},
		} );
	}

	/**
	 * Payments page functionality.
	 */
	function initPaymentsPage () {
		loadPayments();

		$( '#search-container' ).on( 'submit', function ( e ) {
			e.preventDefault();
			loadPayments();
		} );
	}

	/**
	 * Resets the payments table.
	 */
	function resetPaymentForm () {
		$( '.payments-table tbody' ).empty();
	}

	/**
	 * Loads payments from the server.
	 */
	function loadPayments () {
		resetPaymentForm();

		const searchPhrase = $( '#input_search' ).val();

		$.ajax( {
			type: 'POST',
			dataType: 'json',
			url: '/cp/modules/affiliate/json/load-payments.php',
			data: {
				search_phrase: searchPhrase,
			},
			success ( data ) {
				$( '.invoice-count' ).html( data.details.count );
				$( '.invoice-count-container' ).show();

				if ( data.details.count > 0 ) {
					$.each( data.details.payments, function ( key, payment ) {
						$( '#table.payments-table tbody' ).append( `
							<tr>
								<td>${payment.date}</td>
								<td>${payment.payment_id}</td>
								<td>${payment.invoice_nr}</td>
								<td>&euro; ${payment.amount}</td>
								<td>${payment.payment_status}</td>
							</tr>
						` );
					} );
				} else {
					$( '#table.payments-table tbody' ).append(
						`<tr><td colspan="5">${t( 'Geen uitbetalingen gevonden' )}</td></tr>`
					);
				}
			},
			error ( xhr ) {
				$( '.status' ).addClass( 'bg-danger' );
				$( '.status' ).removeClass( 'bg-success' );
				$( '.status' ).html( $.parseJSON( xhr.responseText ).status_description );
				$( '.status' ).fadeIn();
				setTimeout( function () {
					$( '.status' ).fadeOut();
				}, 10000 );
			},
		} );
	}

	/**
	 * Shows toast notification based on config.
	 *
	 * @param {Object} config - Configuration object with toast settings.
	 */
	function showToastNotification ( config ) {
		if ( config.toastType && config.toastMessage ) {
			$.toast( {
				heading: config.toastType === 'success' ? t( 'Succesvol' ) : t( 'Foutmelding' ),
				text: config.toastMessage,
				position: 'bottom-left',
				loaderBg: '#87888a',
				icon: config.toastType,
				hideAfter: 6000,
				stack: 6,
			} );
		}
	}
};

